import moment from "moment";

export const parseTimeToUTC = time => {
  const date = moment()
    .set("hour", time?.hour)
    .set("minutes", time?.minutes)
    .utc()
    .format("HH:mm");

  return date;
};

export const parseTimeToUTCSS = time => {
  const date = moment()
    .set("hour", time?.hour)
    .set("minutes", time?.minutes)
    .set("seconds", "00")
    .utc()
    .format("HH:mm:ss");

  return date;
};

export const parseTimeToLocal = (
  time,
  parsedDate = moment().format("YYYY-MM-DD")
) => {
  const localDate = moment.utc(parsedDate + " " + time).toDate();
  const formattedDate = moment(localDate).format("HH:mm");

  return formattedDate;
};

export const parseDateToLocalWithTime = (
  time,
  parsedDate = moment().format("YYYY-MM-DD")
) => {
  const localDate = moment.utc(parsedDate + " " + time).toDate();
  const formattedDate = moment(localDate).format("YYYY-MM-DD");

  return formattedDate;
};

export const parseDateInWithTime = (
  time,
  parsedDate = moment().format("YYYY-MM-DD")
) => {
  const localDate = new Date(parsedDate + " " + time);
  let formattedDate;
  if (String(new Date(localDate).getDate()).length == 0) {
    formattedDate =
      new Date(localDate).getFullYear() +
      "-" +
      (new Date(localDate).getMonth() + 1) +
      "-0" +
      new Date(localDate).getDate();
  } else if (String(new Date(localDate).getMonth() +1).length  == 1) {
    if (String(new Date(localDate).getDate()).length == 1) {
      formattedDate =
    new Date(localDate).getFullYear() +
    "-0" +
    (new Date(localDate).getMonth() + 1) +
    "-0" +
    new Date(localDate).getDate();
    }
    
    else{
      formattedDate =
      new Date(localDate).getFullYear() +
      "-0" +
      (new Date(localDate).getMonth() + 1) +
      "-" +
      new Date(localDate).getDate();
    }
  }else if (String(new Date(localDate).getDate()).length == 1) {
    if (String(new Date(localDate).getDate()).length == 1) {
      formattedDate =
    new Date(localDate).getFullYear() +
    "-" +
    (new Date(localDate).getMonth() + 1) +
    "-0" +
    new Date(localDate).getDate();
    }
    else{
      formattedDate =
    new Date(localDate).getFullYear() +
    "-0" +
    (new Date(localDate).getMonth() + 1) +
    "-0" +
    new Date(localDate).getDate();
    }
  }
   else  {
    formattedDate =
      new Date(localDate).getFullYear() +
      "-" +
      (new Date(localDate).getMonth() + 1) +
      "-" +
      new Date(localDate).getDate();
      
  }
  return formattedDate;
};

export const parseUTCtoLocalDateTime = (dateTime) => {
  const parsedDate = moment(dateTime).format("YYYY-MM-DD");
  const time = moment(dateTime).format("hh:mm:ss");
  const DateTime = moment.utc(dateTime).toDate();
  const Time=new Date(DateTime)
  let hours = Time.getHours();
  let minutes = Time.getMinutes();
  let ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes.toString().padStart(2, '0');
  let strTime =ampm;
  const localDate = moment.utc(parsedDate + " " + time ).toDate();
  const formated_date = moment(localDate).format("ddd DD MMM hh:mm ");
  const final_date= formated_date +strTime
  return final_date;
};

export const parseDateToUTC = date => {
  const formattedDate = moment(date).format("YYYY-MM-DD");
  return formattedDate;
};

export const parseDateToLocal = date => {
  const localDate = moment(date).toDate();

  return localDate;
};

export const getMeridiem = time => {
  const hour = parseInt(time.split(":")[0]);

  if (hour <= 11) return "AM";
  else return "PM";
};

export const getUTCDateTime = (date, time) => {
  const utc = new Date(date + " " + time).toUTCString();
  let formated_date = "";
  // const utc_date = new Date(date + " " + time).toUTCString();
  if (String(new Date(utc).getUTCDate()).length == 1) {
    if (String(new Date(utc).getUTCMonth()+1).length == 1)  {
    formated_date =
      new Date(utc).getUTCFullYear() +
      "-0" +
      (new Date(utc).getUTCMonth() + 1) +
      "-0" +
      new Date(utc).getUTCDate();
    }
    else{
      formated_date =
      new Date(utc).getUTCFullYear() +
      "-" +
      (new Date(utc).getUTCMonth() + 1) +
      "-0" +
      new Date(utc).getUTCDate();
    }
  } 
  else if (String(new Date(utc).getUTCMonth()+1).length == 1) {
    if (String(new Date(utc).getUTCDate()).length == 1) {
      formated_date =
    new Date(utc).getUTCFullYear() +
    "-0" +
    (new Date(utc).getUTCMonth() + 1) +
    "-0" +
    new Date(utc).getUTCDate();
    }
    
    else{
      formated_date =
      new Date(utc).getUTCFullYear() +
      "-0" +
      (new Date(utc).getUTCMonth() + 1) +
      "-" +
      new Date(utc).getUTCDate();
    }
  }else  {
    formated_date =
      new Date(utc).getUTCFullYear() +
      "-" +
      (new Date(utc).getUTCMonth() + 1) +
      "-" +
      new Date(utc).getUTCDate();
      
  } 
  // const formated_time =
  //   new Date(utc).getUTCHours() +
  //   ":" +
  //   new Date(utc).getUTCMinutes() +
  //   ":" +
  //   new Date(utc).getUTCSeconds();

  // const final_time =
  //   String(new Date(utc).getUTCHours()).length == 1 ? "0" + formated_time : "";

  return formated_date;
};

export const convertTimeTo12HourFormatChat= (timeString) => {
  let hours = parseInt(timeString.substring(8, 10));
  let minutes = timeString.substring(11, 13)
  let meridian = 'AM';
  
  if (hours >= 12) {
  meridian = 'PM';
  if (hours > 12) {
  hours -= 12;
  }
  }
  
  const formattedTime = `${hours}:${minutes} ${meridian}`;
  return formattedTime;
  }
  
  export const convertTimeTo12HourFormat= (timeString) => {
  let hours = parseInt(timeString.substring(0, 2));
  let minutes = timeString.substring(3, 5);
  let meridian = 'AM';
  
  if (hours >= 12) {
  meridian = 'PM';
  if (hours > 12) {
  hours -= 12;
  }
  }
  
  const formattedTime = `${hours}:${minutes} ${meridian}`;
  return formattedTime;
}

